import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: process.env.MIX_SENTRY_DSN,
    integrations: [
        new VueIntegration({
            Vue,
            attachProps: true,
            logErrors: true
        })
    ]
});

window.Sentry = Sentry;

export default Sentry;
